// src/components/landing/TestimonialsSection.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const TESTIMONIALS = [
  { quote: 'The DCA certificate from BSS IT Mission helped me clear the KPSC selection. The course was thorough and the faculty was very supportive throughout my preparation.', name: 'Sreelakshmi P.', role: 'KPSC Clerk, Thiruvananthapuram', initials: 'SP', color: '#1d6cf0' },
  { quote: 'I enrolled in the MS Office course while still in college. The certification was immediately recognized when I applied for my first government job in Ernakulam.', name: 'Arun Kumar M.', role: 'Data Entry Operator, Ernakulam', initials: 'AK', color: '#10b981' },
  { quote: 'BSS IT Mission center in Kozhikode changed my life. The batch timings were flexible and the practical training was excellent. Got placed within 2 months of completion.', name: 'Fathima Nazar', role: 'Office Assistant, Kozhikode', initials: 'FN', color: '#7c3aed' },
  { quote: 'The Web Development course was exactly what I needed to start freelancing. The trainer had real project experience and guided us beyond just theory.', name: 'Vishnu S.', role: 'Freelance Web Developer, Thrissur', initials: 'VS', color: '#f59e0b' },
];

export default function TestimonialsSection() {
  return (
    <Box sx={{ bgcolor: '#f0f7ff', py: { xs: 8, md: 12 }, px: { xs: 3, md: 8 } }}>
      <Box sx={{ textAlign: 'center', mb: 7 }}>
        <Typography sx={{ fontSize: '0.68rem', fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#1d6cf0', mb: 1.5 }}>
          Stories
        </Typography>
        <Typography sx={{ fontSize: { xs: '1.7rem', md: '2.4rem' }, fontWeight: 900, color: '#1e293b', mb: 1.5 }}>
          What Our Students Say
        </Typography>
        <Typography sx={{ color: '#64748b', fontSize: '0.95rem', maxWidth: 480, mx: 'auto', lineHeight: 1.75 }}>
          Graduates who found jobs through BSS IT Mission certification.
        </Typography>
      </Box>

      <Box sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' },
        gap: 3,
        maxWidth: 1200,
        mx: 'auto',
      }}>
        {TESTIMONIALS.map((t, i) => (
          <motion.div
            key={t.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            style={{ display: 'flex' }}
          >
            <Box sx={{
              bgcolor: '#fff', width: '100%',
              border: '1px solid #e2eaf5', borderRadius: 5,
              p: 3.5, boxShadow: '0 4px 20px rgba(29,108,240,0.07)',
              display: 'flex', flexDirection: 'column',
              transition: 'border-color 0.3s, transform 0.3s, box-shadow 0.3s',
              '&:hover': { borderColor: '#93c5fd', transform: 'translateY(-4px)', boxShadow: '0 16px 40px rgba(29,108,240,0.14)' },
            }}>
              <Typography sx={{ color: '#f59e0b', fontSize: '1rem', mb: 2, letterSpacing: 2 }}>★★★★★</Typography>
              <Typography sx={{ color: '#475569', fontSize: '0.88rem', lineHeight: 1.75, mb: 2.5, fontStyle: 'italic', flex: 1 }}>
                "{t.quote}"
              </Typography>
              {/* Initials circle instead of avatar photo */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{
                  width: 44, height: 44, borderRadius: '50%', flexShrink: 0,
                  background: `linear-gradient(135deg, ${t.color}, ${t.color}bb)`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff', fontWeight: 800, fontSize: '0.85rem',
                  boxShadow: `0 4px 12px ${t.color}40`,
                }}>
                  {t.initials}
                </Box>
                <Box>
                  <Typography sx={{ fontSize: '0.88rem', fontWeight: 700, color: '#1e293b' }}>{t.name}</Typography>
                  <Typography sx={{ fontSize: '0.75rem', color: '#94a3b8', mt: 0.25 }}>{t.role}</Typography>
                </Box>
              </Box>
            </Box>
          </motion.div>
        ))}
      </Box>
    </Box>
  );
}
